
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/outlet/amusement-park-management-software",
      function () {
        return require("private-next-pages/outlet/amusement-park-management-software.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/outlet/amusement-park-management-software"])
      });
    }
  